export default __webpack_public_path__ + "static/media/instagram-icon.2a73bbfa.png";